import React, { FC } from 'react';
import { Box, makeStyles } from '@dxb-web-ui-framework/design-system';
import { DashboardHeroBanner, CardHeroBanner } from '../../Generic/HeroBanner';
import { HeroBannerTypes } from '../types';
import { HeroContent } from '../../Generic/types';

export interface HeroBannerLayoutProps {
  heroMoto?: string;
  heroSlogan?: string;
  containerType: HeroBannerTypes.DASHBOARD | HeroBannerTypes.CARD_REQUEST;
  heroBackground?: string;
  heroImage: string;
  heroImageSize: string;
  background?: string;
  dataTestId: string;
  heroContent?: HeroContent;
  backButton?: boolean;
  onBackOverride?: () => void;
}

const useStyles = makeStyles(({ spacing }) => ({
  container: {
    paddingTop: spacing(14),
    backgroundImage: ({ backgroundImage }: { backgroundImage: string | undefined }) => `url("${backgroundImage}")`,
    backgroundRepeat: ({ backgroundImage }: { backgroundImage: string | undefined }) =>
      backgroundImage !== undefined ? 'no-repeat' : 'unset',
    backgroundSize: ({ backgroundImage }: { backgroundImage: string | undefined }) =>
      backgroundImage !== undefined ? 'cover' : 'unset',
    backgroundPosition: ({ backgroundImage }: { backgroundImage: string | undefined }) =>
      backgroundImage !== undefined ? 'center' : 'unset',
    boxShadow: ({ backgroundImage }: { backgroundImage: string | undefined }) =>
      backgroundImage ? '0px 0px 10px rgba(0, 0, 0, 0.2)' : 'unset',
  },
}));

const HeroBannerLayout: FC<HeroBannerLayoutProps> = ({
  heroBackground,
  heroImage,
  heroImageSize,
  heroMoto,
  heroSlogan,
  dataTestId,
  containerType,
  children,
  heroContent,
  backButton,
  onBackOverride,
}) => {
  const styles = useStyles({
    backgroundImage: heroBackground,
  });

  return (
    <>
      <Box
        component={'main'}
        className={styles.container}
        data-testid={dataTestId}
        display={'flex'}
        flexDirection={'column'}>
        <Box mt={backButton ? 1 : 0}>
          {containerType === HeroBannerTypes.DASHBOARD && (
            <DashboardHeroBanner heroImage={heroImage} moto={heroMoto} slogan={heroSlogan} />
          )}
          {containerType === HeroBannerTypes.CARD_REQUEST && (
            <CardHeroBanner
              heroImage={heroImage}
              heroImageSize={heroImageSize}
              moto={heroMoto}
              slogan={heroSlogan}
              content={heroContent}
              hasBackButton={backButton}
              onBackOverride={onBackOverride}
            />
          )}
        </Box>
      </Box>
      {children}
    </>
  );
};

export { HeroBannerLayout };
